module.exports = __webpack_public_path__ + "img/home.ad8d7c41.svg";